const UI_SVELTE_INIT = 'ui.svelte.init';

const UI_SVELTE_UPDATE = 'ui.svelte.update';

const DEFAULT_COMPONENT_NAME = 'Svelte Component';

export { DEFAULT_COMPONENT_NAME, UI_SVELTE_INIT, UI_SVELTE_UPDATE };
//# sourceMappingURL=constants.js.map
